var map = {
	"./1.webp": 8467,
	"./10.webp": 5812,
	"./12.webp": 4708,
	"./13.webp": 3751,
	"./14.webp": 8653,
	"./15.webp": 1886,
	"./16.webp": 9006,
	"./17.webp": 9622,
	"./18.webp": 7777,
	"./19.webp": 5263,
	"./2.webp": 2257,
	"./20.webp": 7535,
	"./21.webp": 3535,
	"./22.webp": 2254,
	"./23.webp": 5277,
	"./24.webp": 4274,
	"./25.webp": 1174,
	"./26.webp": 4194,
	"./3.webp": 3196,
	"./4.webp": 599,
	"./5.webp": 1963,
	"./6.webp": 4045,
	"./7.webp": 3259,
	"./8.webp": 8799,
	"./9.webp": 6531,
	"./food_1.webp": 206,
	"./food_2.webp": 196,
	"./main.webp": 2546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2523;